import React, { useContext, useEffect, useState } from "react";
import { tipoDocumentos, poseeCorreduria } from "../../data/mochaData";
import DivRow from "../controlsNR/DivRowNR";
import DropDownInput from "../controlsNR/DropDownInputNR";
import DropDownInputNR2 from "../controlsNR/DropDownInputNR2";
import Input from "../controlsNR/InputNR";
import SwitchButton from "../controlsNR/SwitchButtonNR";
import DropDown from "../controlsNR/DropDown";
import http from '../../services/http';
import {endPoints} from '../../utils/constanst'
import Modal from "react-modal";

import {
  DataContextReclamo,
  DataProvier,
} from "../../context/DataContextReclamo";
import {
  TooltipFiguraTramite
} from "../../utils/constanst";

const Step1 = () => {
  const letterPattern = "[ A-Za-zñÑáéíóúÁÉÍÓÚ]+";

  const { tramite, setTramite, changeHandler } = useContext(DataContextReclamo);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [loading, setLoading] = useState(false);



  const handleChange = (e) =>
    setTramite({ ...tramite, [e.target.name]: e.target.value });


    const {
      vehiculoPropio
    } = tramite;
    
        
    const onClickSearch = () => {
     
      setLoading(true);
      http(endPoints.ente(tramite.numeroIdentificacion, tramite.tipoIdentificacion))
          .get()
          .then((res) => {
              
              setTramite({
                  ...tramite
                  , nombre1: res.nombre, apellido1: res.apellido
                  , celular: res.telefonoCelular
                  , correo: res.email
                  ,cargando:false 
              });

          })
          .catch((error) => {
            setTramite({ ...tramite, mensaje: 'No se encontro registro',cargando:false });
             setLoading(false);
             handleShow();
          }).finally( () => {  setLoading(false) }); ;
         
  };

  return (
    <div className="step">
      <DivRow width="100%" className="">

    <DropDownInputNR2
              label="Identificación"
              dataProvider={tipoDocumentos}
              value={tramite.numeroIdentificacion}
              onChange={changeHandler}
              valueSelect={tramite.tipoIdentificacion}
              onChangeSelect={changeHandler}
              field="numeroIdentificacion"
              fieldSelect="tipoIdentificacion"
              title="Documento invalido"
              classNameInput=""
              classLabel = "labelComponent"
              useMask={tramite.tipoIdentificacion === "1" ? true : false}
              mask={tramite.tipoIdentificacion === "1" ? "999-999999-9999a" : ""}
              pattern={tramite.tipoIdentificacion === "1" ? "\d\d\d-\d\d\d\d\d\d-\d\d\d\d\w" : ""}
              isrequired = {true}
            useiconSearch={true}
            onClickIconSearch ={onClickSearch}
              
        />

        

        <Input
              label="Nombres*"
              field="nombre1"
              placeholder="Nombres"
              value={tramite.nombre1}
              onChange={handleChange}
              pattern={letterPattern}
              title="Documento invalido"
              classNameInput="sg-input-field-nr"
              classTitle="labelComponent"
              isrequired={true}
            />

        <Input
              label="Apellidos*"
              field="apellido1"
              placeholder="Apellidos"
              value={tramite.apellido1}
              onChange={handleChange}
              pattern={letterPattern}
              classNameInput="sg-input-field-nr"
              classTitle="labelComponent"
              isrequired={true}
            />
   
        
        <Input
          label="Correo electrónico*"
          placeholder="ejemplo@ejemplo.com"
          field="correo"
          value={tramite.correo}
          onChange={handleChange}
          classNameInput="sg-input-field-nr"
          type='email'
          classTitle="labelComponent"
        />

        <Input
          label="Número de celular*"
          pattern="\d\d\d\d-\d\d\d\d"
          title="Teléfono inválido"
          type="maskInput"
          mask="9999-9999"
          field="celular"
          placeholder="0000-0000"
          value={tramite.celular}
          onChange={handleChange}
          classNameInput="sg-input-field-nr"
          classTitle="labelComponent"
        />

        <SwitchButton
          label="Figura de reclamo"
          value={tramite.figura}
          onClick={(value) => setTramite({ ...tramite, figura: value })}
          si="Perjudicado"
          no="Asegurado"
          className="sg-input-field-nr"
          name={tramite.figura}
          classLabel="labelComponent"
          usetooltip = "true"
          tooltipText={TooltipFiguraTramite.text}
          tooltipTitle ={TooltipFiguraTramite.title}

        />

        <DropDownInput
          label="¿Posee correduría?"
          dataProvider={poseeCorreduria}
          value={tramite.nombreCorreduria}
          onChange={changeHandler}
          valueSelect={tramite.poseeCorreduria}
          onChangeSelect={changeHandler}
          field="nombreCorreduria"
          fieldSelect="poseeCorreduria"
          title="Documento invalido"
          classNameInput="sg-input-field-nr"
          classLabel = "labelComponent"
         isrequired = {false}
          
        />

          <SwitchButton
          label="¿Es usted dueño del vehículo?*"
          value={tramite.vehiculoPropio}
          onClick={(value) => setTramite({ ...tramite, vehiculoPropio: value })}
          si="Si"
          no="No"
          className="sg-input-field-nr nr-spacio-bottom"
          name={tramite.vehiculoPropio}
          classLabel="labelComponent "
        />

          <Input
          label="Nombre completo del conductor"
          field="nombrePropietarioVehiculo"
          value={tramite.nombrePropietarioVehiculo}
          onChange={handleChange}
          classNameInput="sg-input-field-nr"
          required ={!vehiculoPropio}
          classTitle="labelComponent"
        />

      </DivRow>
      <Modal className="modal" isOpen={show} show={show} ariaHideApp={false}>
            <div className="modal-title">
                <span className="txt-title-modal">Información</span>
            </div>
            <div className="modal-body-info">
                {tramite.mensaje}
            </div>
            <div className="modal-footer">
                <button type="button" className="modal-btn-close" onClick={handleClose}>Cerrar</button>
            </div>
        </Modal>
        <Modal className="modal" isOpen={loading} show={loading} ariaHideApp={false}>
                <div className="dialog-center-content">
                    <p className="text-center">Cargando...</p>
                </div>
            </Modal>
    </div>
  );
};

export default Step1;
